import React from "react";
import Panel from "muicss/lib/react/panel";
import axios from "axios";
import { scale, format } from "d3";
import BarChart from "react-d3-components/lib/BarChart";
import clone from "lodash/clone";
import each from "lodash/each";
import { connect } from "react-redux";
import language from "./../dictionary/index";

class PublicNetworkLedgersHistoryChart extends React.Component {
  constructor(props) {
    super(props);
    this.panel = null;
    this.colorScale = scale.category10();
    this.state = {
      loading: true,
      chartWidth: 400,
      chartHeight: this.props.chartHeight || 120,
    };
  }

  componentDidMount() {
    this.getLedgers();
    setInterval(() => this.getLedgers(), 1000 * 60 * 5);
    // Update chart width
    this.updateSize();
    setInterval(() => this.updateSize(), 5000);
  }

  updateSize() {
    let value = this.panel.offsetWidth - 20;
    if (this.state.chartWidth != value) {
      this.setState({ chartWidth: value });
    }
  }

  getLedgers() {
    axios.get("/api/ledgers/public").then((response) => {
      console.log(response.data)
      let data = [
        {
          label: "Transactions",
          values: [],
        },
        {
          label: "Operations",
          values: [],
        },
      ];
      each(response.data, (day) => {
        data[0].values.unshift({ x: day.date, y: day.transaction_count });
        data[1].values.unshift({ x: day.date, y: day.operation_count });
      });
      
      this.setState({ loading: false, data });
    }).catch(err=>{
      console.log(err)
    });
  }

  render() {
    return (
      <div
        ref={(el) => {
          this.panel = el;
        }}
      >
        <Panel>
          <div className="widget-name">
            <p
              style={{
                textAlign: this.props.language == "persian" ? "right" : "left",
              }}
            >
              <span style={{ borderBottom: "2px solid #0074B7" }}>
                {" "}
                {language.successfulTx[this.props.language]}{" "}
              </span>{" "}
              {language.amp[this.props.language]}
              <span style={{ borderBottom: "2px solid #FF6F00" }}>
                {" "}
                {language.operation[this.props.language]}{" "}
              </span>
              {language.last[this.props.language]}{" "}
              {language.daysAgo[this.props.language]}: {this.props.network}
            </p>
          </div>
          {this.state.loading ? (
            `${language.loading[this.props.language]}`
          ) : (
            <BarChart
              groupedBars
              data={this.state.data}
              width={this.state.chartWidth}
              colorScale={this.colorScale}
              height={this.state.chartHeight}
              margin={{ top: 10, bottom: 28, left: 50, right: 10 }}
            />
          )}
        </Panel>
      </div>
    );
  }
}

const mapSateToProps = ({ CommonReducer }) => {
  return {
    language: CommonReducer.language,
  };
};

export default connect(mapSateToProps)(PublicNetworkLedgersHistoryChart);



// WEBPACK FOOTER //
// ./frontend/components/PublicNetworkLedgersHistoryChart.js